import React from 'react'
import confirm from '../Assets/confirm.png';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function OrderDone() {
    const navigate = useNavigate();
      const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const orderId = searchParams.get("orderId");
  return (
 <div className="page-content cart-page confirmpage">

      <div className="maxw cart-container" style={{ marginTop: "30px" }}>
            <div className='d-flex align-items-center justify-content-center'><img src={confirm} alt="Confirm" /></div>
        <h2 className="fw-bold text-center mt-2">Order Confirmed</h2>
          <h3 className="text-center mt-2 mb-0">Your Order ID : <b>{orderId}</b></h3>
          <h3 className="text-center mb-0 ">Thank You For Ordering From Gedar Store &lt;3</h3>
                    <h4 className="text-center">Our team will contact you shortly.</h4>
  <p className="text-center mb-2 mt-0">Please save this order ID somewhere safe. You will need it for order tracking, customer support, or any inquiries regarding this purchase.</p>
<div className='d-flex align-items-center justify-content-center mt-4'>
     <button className="btn btn-primary" onClick={()=>{navigate('/')}}>Continue Shopping</button>

</div>
          
      </div>
    </div>
      )
}
